<app-gmao-spinner *ngIf="!stats || !stats.stats || !pizzadoor "></app-gmao-spinner>
<br>
<ng-container *ngIf="stats && stats.stats && pizzadoor">
    <div class="view-item  installedmachines">
        <p>Distributeurs installés au mois de <strong>{{displayedMonth}}</strong> : </p>
        <p>PizzaDoor : {{pizzadoor}} </p>
        <p>PaniDoor : {{panidoor}} </p>
    </div>
    <div class="view-item row" id="nbDistributeurs">
        <p>{{stats.stats.installations_actives_count}} distributeurs actuellement en exploitation</p>
    </div>
    <mat-tab-group mat-align-tabs="center">
        <mat-tab label="Avertissements">
            <app-home-warning></app-home-warning>
        </mat-tab>
        <mat-tab label="Informations générales">
            <div class="view-item">
                <div *ngFor="let year of years" class="row view-item">
                    <p class="col-1 d-flex align-items-center font-weight-bold">
                        {{year.year}}
                    </p>
                    <div class="col-11">
                        <table class="table table-striped home-table table-sm">
                            <thead>
                                <th scope="col">Monnaie</th>
                                <th class="number" scope="col">Pizzas</th>
                                <th class="number" scope="col">CA</th>
                            </thead>
                            <tbody>
                                <tr *ngFor="let currency of year.currencies">
                                    <td>{{currency.DEVISE}}</td>
                                    <td class="number">{{currency.PIZZAS | number: '1.0-0' : 'fr'}}</td>
                                    <td class="number">{{currency.CA | number: '1.0-0' : 'fr'}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </mat-tab>
        <mat-tab label="Gestion des licences">
            <div class="view-item">
                <table class="table table-striped home-table table-sm">
                    <thead>
                        <th scope="col">Machine</th>
                        <th scope="col">Installation</th>
                        <th scope="col">Fin évaluation ( date max )</th>
                    </thead>
                    <!-- les articles modifiés dernièrement dans l'omniscience -->
                    <tbody>
                        <tr *ngFor="let licence of stats.licences" (click)="getDetailPage(licence.id_installation)">
                            <td>{{licence.numero_serie}}</td>
                            <td>{{licence.nom_installation}}</td>
                            <td>{{licence.evaluation_expires_date}} ({{licence.evaluation_remaining_time}} jours,
                                {{licence.evaluation_pizzas}} pizzas)</td>
                        </tr>
                    </tbody>

                </table>
            </div>
        </mat-tab>
        <mat-tab label="Prochaines installations">
            <div class="view-item">
                <table class="table table-striped home-table table-sm">
                    <thead>
                        <th scope="col">Nom installation</th>
                        <th scope="col">Ville</th>
                        <th scope="col">Propriétaire</th>
                        <th scope="col">Date installation</th>
                        <th scope="col">Machine</th>
                    </thead>
                    <!-- les articles modifiés dernièrement dans l'omniscience -->
                    <tbody>
                        <tr *ngFor="let installation of stats.installations.projets"
                            (click)="getDetailPage(installation.id_installation)">
                            <td>{{installation.nom_installation}}</td>
                            <td>{{installation.ville}}</td>
                            <td>{{installation.proprietaire}}</td>
                            <td>{{installation.date_installation}}</td>
                            <td>{{installation.numero_serie}}</td>
                        </tr>
                    </tbody>

                </table>
            </div>
        </mat-tab>
        <mat-tab label="Dernières modifications de l'omniscience">
            <div class="view-item">
                <table class="table table-striped home-table table-sm">
                    <thead>
                        <th scope="col">Article</th>
                        <th scope="col">Auteur</th>
                        <th scope="col">Date de modification</th>
                    </thead>
                    <!-- les articles modifiés dernièrement dans l'omniscience -->
                    <tbody>
                        <tr routerLink="/wiki" *ngFor="let kb of stats.kbs">
                            <td>{{kb.title}}</td>
                            <td>{{kb.auteur}}</td>
                            <td>{{kb.date_modification_date}} {{kb.date_modification_time}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </mat-tab>
    </mat-tab-group>
</ng-container>